export { default } from './MainLoader'


// WEBPACK FOOTER //
// ./src/components/Loader/MainLoader/index.js